import { render, staticRenderFns } from "./classTemp.vue?vue&type=template&id=6f4e41ef&scoped=true&"
import script from "./classTemp.vue?vue&type=script&lang=js&"
export * from "./classTemp.vue?vue&type=script&lang=js&"
import style0 from "./classTemp.vue?vue&type=style&index=0&id=6f4e41ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e41ef",
  null
  
)

export default component.exports